import { ChangeEvent, useCallback, useState } from 'react';

export const useInputField = (initialValue = '') => {
  const [value, setValue] = useState(initialValue);

  const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  }, []);

  return {
    value,
    onChange,
    setValue,
  };
};

export default useInputField;
